import { Dialog } from "@mui/material";

export const ModalContentDesktop = ({ open, closeModal, children, maxWidth = "sm", ...rest }) => (
    <Dialog open={open} onClose={closeModal} maxWidth={maxWidth} fullWidth {...rest}>
        {children}
    </Dialog>
);
